<template>
  <div>
    <Modal v-if="show" :show="show" @close="onClose">
      <div class="component">
        <h5 class="component-title">Request for validation</h5>
        <p class="component-paragraph">
          Fill in any additional products when applicable and your question and
          click Send.
        </p>

        <form @submit.prevent="onSend">
          <label for="driver">Driver</label>
          <input
            type="text"
            class="form-control"
            id="driver"
            name="driver"
            :value="driverStr"
            disabled
          />

          <label for="module">Module</label>
          <input
            type="text"
            class="form-control"
            id="module"
            name="module"
            :value="moduleStr"
            disabled
          />

          <label for="quantity">Quantity</label>
          <input
            type="number"
            class="form-control"
            id="quantity"
            name="quantity"
            v-model="quantity"
          />

          <label for="additionalProducts">Addition products</label>
          <input
            type="text"
            class="form-control"
            id="additionalProducts"
            name="additionalProducts"
            v-model="additionalProducts"
          />

          <label for="companyName">Company name</label>
          <input
            type="text"
            class="form-control"
            id="companyName"
            name="companyName"
            :value="userData.company"
            disabled
          />

          <label for="name">Name</label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            :value="userData.name"
            disabled
          />

          <label for="email">Email</label>
          <input
            type="email"
            class="form-control"
            id="email"
            name="email"
            v-model="email"
            required
          />

          <label for="date">Date</label>
          <input
            type="text"
            class="form-control"
            id="date"
            name="date"
            :value="today"
            disabled
          />

          <label for="question">Question</label>
          <textarea
            class="form-control"
            id="question"
            name="question"
            v-model="question"
          />

          <div class="component-button">
            <input
              type="button"
              class="btn btn-outline-secondary"
              value="Cancel"
              @click="onClose"
            />

            <input type="submit" class="btn btn-secondary" value="Send" />
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http } from "@/services/http";
import { mapGetters } from "vuex";

export default {
  name: "RequestValidationModal",
  props: {
    driver: {
      type: Object,
      required: true,
    },
    module: {
      type: Object,
      required: true,
    },
  },
  computed: {
    today() {
      const date = new Date();
      const dd = ("0" + date.getDate()).slice(-2);
      const mm = ("0" + (date.getMonth() + 1)).slice(-2);
      const yyyy = date.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    },
    moduleStr() {
      if (!this.module) {
        return "";
      }
      return `${this.module.name} : ${this.module.nc12}`;
    },
    driverStr() {
      if (!this.driver) {
        return "";
      }
      return `${this.driver.name} : ${this.driver.nc12}`;
    },
    ...mapGetters("brain/auth", ["userData", "isLoggedIn", "activeToken"]),
    ...mapGetters("brain/solutions", ["solution"]),
    ...mapGetters("brain/drivers", ["isWhitelistedSolution"]),
  },
  data() {
    return {
      show: false,
      quantity: 1,
      // pdfUrl: "https://pdf.com",
      additionalProducts: "",
      question: "",
      email: "",
    };
  },
  methods: {
    onClose() {
      this.show = false;
    },
    onSend() {
      this.$store.commit("brain/global/setBusy", true);
      http
        .post("/api/v2/validation-request", {
          email: this.email,
          name: this.userData.name,
          company: this.userData.company,
          driver: this.driverStr,
          module: this.moduleStr,
          quantity: this.quantity,
          solutionPayload: JSON.stringify({
            solution: {
              isWhitelistedSolution: this.isWhitelistedSolution,
              ...this.solution,
            },
            jwt: this.activeToken,
            user: this.isLoggedIn ? this.userData : null,
          }),
          additionalProducts: this.additionalProducts,
          question: this.question,
        })
        .then((response) => {
          this.$store.commit("brain/global/setBusy", false);
          if (!response.data.data.success) {
            this.$snotify.error(
              "The request for validation could not be sent. Please try again later."
            );
          } else {
            this.$snotify.success("Request for validation sent successfully");
            this.show = false;
          }
        })
        .catch(() => {
          this.$store.commit("brain/global/setBusy", false);
          this.$snotify.error(
            "The request for validation could not be sent. Please try again later."
          );
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  overflow-y: auto;
  max-height: calc(100% - 200px);

  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-paragraph {
    font-size: 16px;
  }
  .form-control {
    margin: 0 0 10px 0;
  }
  .component-button {
    margin-top: auto;
    display: flex;
    input {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
